import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-porcentaje-circle',
  templateUrl: './porcentaje-circle.component.html',
  styleUrls: ['./porcentaje-circle.component.scss']
})
export class PorcentajeCircleComponent implements OnInit {
  @Input() porcentaje:any = -1
  @Input() radius:any = 20
  @Input() outerStrokeWidth : any = 5
  constructor() { }

  ngOnInit(): void {
  }

}
